import { render, staticRenderFns } from "./ProfilePaymentCard.vue?vue&type=template&id=28ae63c2&scoped=true"
import script from "./ProfilePaymentCard.vue?vue&type=script&lang=ts"
export * from "./ProfilePaymentCard.vue?vue&type=script&lang=ts"
import style0 from "./ProfilePaymentCard.vue?vue&type=style&index=0&id=28ae63c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae63c2",
  null
  
)

export default component.exports